<template>
    <div>
        <!-- PDF 播放器 -->
        <div class="pdf-viewer">
            <iframe :src="pdfUrl" frameborder="0" class="pdf-iframe"></iframe>
        </div>

    </div>
</template>

<script>
import { defineComponent, } from "vue";

export default defineComponent({
    data() {
        return {
            courseId: null, // 当前课程 ID
            pdfUrl: "", // PDF 文件 URL
        };
    },
    async mounted() {
        this.courseId = this.$route.params.courseId;
        this.fetchBriefFileUrl();
    },
    methods: {
        // 获取 PDF 文件 URL
        async fetchBriefFileUrl() {
            try {
                const response = await this.$axios.post("/api/course/brief-file", {
                    courseId: this.courseId,
                });
                this.pdfUrl = this.$baseFileUrl + response.data.fileUrl;
            } catch (error) {
                console.error("Error fetching PDF file URL:", error);
            }
        },

        
    },
});
</script>

<style scoped>
/* PDF 播放器样式 */
.pdf-viewer {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.pdf-iframe {
    width: 80%;
    height: 80vh;
    border: 1px solid #ccc;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* 对话框按钮操作区域 */
.dialog-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}
</style>
